import React, { useState, useContext } from 'react'
import { IconButton } from '@mui/material'
import { createStyles, makeStyles } from '@mui/styles'

import { ErrorsContext } from '../../../contexts'
import { Logger, LoggerTypes } from '../../../utils'
import { Icon, iconNames } from '../../icons'
import { HeaderErrorsDialog } from '../../header'
import './style.scss'

const useStyles = makeStyles((theme) =>
  createStyles({
    iconNormal: {
      color: theme.palette.primary.main
    },
    iconError: {
      color: theme.palette.error.main
    },
    errorCount: {
      backgroundColor: theme.palette.error.main
    }
  })
)

export const HeaderErrors = () => {
  const styleClasses = useStyles()
  const [openErrorDialog, setOpenErrorDialog] = useState(false)

  const errors = useContext(ErrorsContext)

  const onErrorClick = (e) => {
    e.stopPropagation()
    Logger.trace(LoggerTypes.CONTROLLER, 'HeaderErrors.onErrorClick()', { openErrorDialog, errors })
    setOpenErrorDialog(!openErrorDialog)
  }

  const numErrors = (errors && errors.length) || 0
  const hasError = numErrors > 0

  // Logger.trace(LoggerTypes.CONTAINER, 'HeaderErrors.render()', { openErrorDialog, numErrors })

  return (
    <div className="HeaderErrors">
      <IconButton onClick={onErrorClick} disabled={!hasError}>
        <Icon
          name={iconNames.WARNING}
          size={18}
          className={`icon ${hasError ? styleClasses.iconError : styleClasses.iconNormal}`}
        />
        {hasError ? <span className={`errorCount ${styleClasses.errorCount}`}>{numErrors}</span> : null}
      </IconButton>
      {openErrorDialog && <HeaderErrorsDialog setOpenDialog={setOpenErrorDialog} />}
    </div>
  )
}

HeaderErrors.displayName = 'HeaderErrors'
HeaderErrors.propTypes = {}
HeaderErrors.defaultProps = {}
